export class UserService {
  constructor($resource, ApiService, Constants, DateService) {
    "ngInject";

    this.$resource = $resource;
    this.constants = Constants;
    this.apiService = ApiService;
    this.dateService = DateService;
    this.defaultUserListFilters = {
      limit: null,
      pageId: null,
    };
    this.userListResourceApiUrl = this.apiService.getResourceUrl("/account");
    this.userNoteResourceApiUrl = this.apiService.getResourceUrl(
      "/members/:membersId/note"
    );
    const memberEndpoint = this.apiService.getResourceUrl("/members/:memberId");
    const memberProfileEndpoint = this.apiService.getResourceUrl(
      "/members/:memberId/profile"
    );
    this.userListResource = this.$resource(this.userListResourceApiUrl, null, {
      query: { method: "get", cancellable: true },
    });
    this.userListFilterResource = this.$resource(this.userListResourceApiUrl);
    this.timelineListUrl = this.apiService.getResourceUrl("/timeline/list");
    this.userDetailsResourceApiUrl = this.apiService.getResourceUrl(
      "/account/:accountId"
    );
    this.emailNotificationUrl = this.apiService.getResourceUrl(
      "/account/:accountId/email-notification"
    );
    this.memberResource = this.$resource(memberEndpoint, null, {
      update: {
        method: "PUT",
      },
    });
    this.memberProfileResource = this.$resource(memberProfileEndpoint, null, {
      update: {
        method: "PUT",
      },
    });
    this.userDetailsResource = this.$resource(
      this.userDetailsResourceApiUrl,
      null,
      {
        update: {
          method: "PUT",
        },
      }
    );
    this.userNoteResource = this.$resource(this.userNoteResourceApiUrl, null, {
      update: {
        method: "PUT",
      },
    });
    this.timelineListResource = this.$resource(this.timelineListUrl, null, {
      update: {
        method: "POST",
      },
    });
    this.emailNotificationResource = this.$resource(
      this.emailNotificationUrl,
      null,
      {
        update: {
          method: "POST",
        },
      }
    );
    this.userListQuery = null;
  }

  getUserDetailsById(id) {
    const promise = this.userDetailsResource.get({
      accountId: id,
    }).$promise;
    return promise
      .then(({ details }) => details)
      .catch((error) => {
        console.log("error", error);
        throw this.apiService.getErrorMessage(error);
      });
  }

  getDefaultNotificationContext(id) {
    return {
      accountId: id,
      emailContent: `
        <!DOCTYPE HTML>\n 
        <html>\n  
            <head>\n  
                <meta charset=\"UTF-8\"> \n  
                <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n\t\t\t\t\t\t\t
                <link href=\"https://fonts.googleapis.com/css?family=roboto:400,500,700\" rel=\"stylesheet\">\n\t\t\t\t\t\t\t
                <style>\n 
                    body 
                    {\n  
                        margin: 0;\n   
                        padding: 0;\n 
                        color: #292929;\n                            
                        font-family: roboto;\n  
                        font-size: 1rem;\n  
                    }\n  
                    p {\n   
                        margin: 0;\n  
                        padding: 0;\n  
                    }\n 
                </style>\n 
            </head>\n  
            <body>\n
                <p style=\"font-family:'Roboto'; color: #000; font-size :1rem; word-wrap: break-word; line-height: 1.4;\">
                    <p> Hi {{firstName}}, </p> <br><br><br>


                    
                    Thanks,
                    CMVR Team                        
                </p>\n\n  
            </body>\n \n  
        </html>
    
    `,
    };
  }

  sendUserEmailNotificationById(details) {
    let value = {
      emailContent: details.emailContent,
    };
    const promise = this.emailNotificationResource.update(
      {
        accountId: parseInt(details.accountId),
      },
      value
    ).$promise;
    return promise
      .then((response) => response)
      .catch((error) => {
        throw this.apiService.getErrorMessage(error);
      });
  }

  getNoteDetailsById(id) {
    const promise = this.userNoteResource.get({
      membersId: id,
    }).$promise;
    return promise
      .then(({ details }) => details)
      .catch((error) => {
        console.log("error", error);
        throw this.apiService.getErrorMessage(error);
      });
  }

  sendUserNoteById(details, { membersId }) {
    const promise = this.userNoteResource.update(
      { membersId: parseInt(membersId) },
      details
    ).$promise;
    return promise
      .then((response) => response)
      .catch((error) => {
        throw this.apiService.getErrorMessage(error);
      });
  }

  _getUserDetailsObject(details) {
    const {
      dob,
      email,
      name,
      rank,
      rankId,
      roleId,
      eosDate,
      roleName,
      accountId,
      commander,
      department,
      phoneNumber,
      noteByAdmin,
      maritalStatus,
      branchService,
      batchServiceId,
      accountCreatedOn,
      startDateOfService,
      militaryOccupation,
      militaryOccupationId,
      noteByCareerCounselor,
      enrolledInSpecialPrograms,
      subscribeToWeeklyNewsletter,
    } = details;

    const {
      enpp = null,
      jobCorps = null,
      skillbridge = null,
      etsSponsorship = null,
    } = enrolledInSpecialPrograms || {};

    // const phoneUtil = PhoneNumberUtil.getInstance();
    // let phoneNumber = details.phoneNumber;
    // let phoneDialCode = details.phoneDialCode;
    // if (phoneNumber) {
    //   const number = phoneUtil.parseAndKeepRawInput(
    //     phoneNumber,
    //     details.phoneCountryCode
    //   );
    //   phoneNumber = phoneUtil.format(number, PhoneNumberFormat.NATIONAL);
    //   phoneDialCode =
    //     phoneDialCode.indexOf("+") === -1 ? `+${phoneDialCode}` : phoneDialCode;
    //   phoneNumber = `${phoneDialCode} ${phoneNumber}`;
    // }
    let data = {
      dob,
      email,
      name,
      rank,
      rankId,
      roleId,
      roleName,
      commander,
      accountId,
      department,
      phoneNumber,
      noteByAdmin,
      maritalStatus,
      branchService,
      batchServiceId,
      accountCreatedOn,
      militaryOccupation,
      noteByCareerCounselor,
      militaryOccupationId,
      enrolledInSpecialPrograms,
      subscribeToWeeklyNewsletter,
      enpp: enpp ? "Yes" : enpp === null ? "-" : "No",
      jobCorps: jobCorps ? "Yes" : jobCorps === null ? "-" : "No",
      skillbridge: skillbridge ? "Yes" : skillbridge === null ? "-" : "No",
      etsSponsorship: etsSponsorship
        ? "Yes"
        : etsSponsorship === null
        ? "-"
        : "No",
      eosDate: eosDate ? this.dateService.parseDateFromServerDate(eosDate) : "",
      startDateOfService: startDateOfService
        ? this.dateService.parseDateFromServerDate(startDateOfService)
        : "",
      status: details.status,
      steps: details.steps,
      currentLocation: details.currentLocation ? details.currentLocation : "",
      dutyLocation: details.dutyLocation ? details.dutyLocation : "",
      profileUuid: details.uuid ? details.uuid : "",
      profilePicUrl: details.uuid
        ? this.apiService.getImageUrl(`${details.uuid}`)
        : "",
      stepsStatus: details.stepsStatus,
      preferredLocations: details.preferredLocations.reduce(
        (accum, value, index) => {
          const { details } = value;
          if (
            details.hasOwnProperty("cityName") ||
            details.hasOwnProperty("stateCode")
          ) {
            accum.push(`${details.cityName}, ${details.stateCode}`);
          }
          return accum;
        },
        []
      ),
      lastActivityDate: details.lastActivityDate,
      veteramProgressPercent: details.veteramProgressPercent,
      spouseProgressPercent: details.spouseProgressPercent,
      remainingActiveDaysOfService: details.remainingActiveDaysOfService,
      commander: details.commander,
      phoneDialCode: details.phoneDialCode,
    };
    return data;
  }

  getUserList(userListFilterObject) {
    if (this.userListQuery) {
      this.userListQuery.$cancelRequest();
    }
    this.userListQuery = this.userListResource.query(
      this._setUserListFilterObject(
        userListFilterObject || this.defaultUserListFilters
      )
    );
    return this.userListQuery.$promise.then(({ details }) => details);
  }

  getUserByUserId(userId) {
    const promise = this.userDetailsResource.get({ user_id: userId }).$promise;
    return promise
      .then(({ data }) => this._getUserObject(data))
      .catch((error) => {
        throw this.apiService.getErrorMessage(error);
      });
  }

  getUserListRadioButtonOptionList() {
    return [
      {
        type: "multilevelCheckbox",
        title: "Source",
        key: "source",
        isOpen: false,
      },
      {
        type: "radio",
        title: "Timeline",
        isOpen: false,
        data: this.getTimelineFilterOptions(),
        key: "Timeline",
        defaultSelectedId: 11,
      },
    ];
  }

  getTimelineFilterOptions() {
    return [
      {
        id: 11,
        name: "self",
        value: "Self",
        sendKey: "self",
        isSelected: true,
      },
      {
        id: 12,
        isSelected: false,
        name: "spouse checklist",
        value: "SpouseChecklist",
        sendKey: "spouse checklist",
      },
    ];
  }

  getUserListFilterObject() {
    return [
      ...this.getUserListRadioButtonOptionList(),
      ...this.getUserTypesMultiLevelCheckBoxObject(),
    ];
  }

  getUserTypesMultiLevelCheckBoxObject() {
    // {
    //   type: "multilevelCheckbox",
    //   title: "Stages",
    //   isOpen: false,
    //   key: "Stages",
    // },
    return [
      {
        type: "multilevelCheckbox",
        title: "Preferred Location",
        key: "preferredlocation",
        isOpen: false,
      },
    ];
  }

  _getTimelineObjectList(list) {
    return list.map((value) => this._getMultilevelCheckboxObject(value));
  }

  _getMultilevelCheckboxObject(data) {
    return {
      id: data.timelineId,
      // value: "step1",
      name: data.displayName,
      title: data.displayName,
      isSelected: false,
      showinwebsite: data.showinwebsite,
      isSpouseChecklist: data.isSpouseChecklist,
    };
  }

  getStagesCheckboxesObject() {
    const promise = this.timelineListResource.get().$promise;
    return promise
      .then(({ details }) => this._getTimelineObjectList(details.timelineList))
      .catch((error) => {
        console.log("error", error);
      });
  }

  getStatusRadioButtonOptions() {
    return [
      {
        id: 1,
        name: "All",
        value: "All",
        sendKey: "All",
        isSelected: true,
      },
      {
        id: 2,
        isSelected: false,
        name: "not yet started",
        value: "NotYetStarted",
        sendKey: "not yet started",
      },
      {
        id: 3,
        isSelected: false,
        name: "in progress",
        value: "InProgress",
        sendKey: "in progress",
      },
      {
        id: 4,
        isSelected: false,
        name: "completed",
        value: "Completed",
        sendKey: "completed",
      },
    ];
  }

  deleteMember(id) {
    const promise = this.memberResource.delete({
      memberId: id,
    }).$promise;

    return promise.catch((error) => {
      throw this.apiService.getErrorMessage(error);
    });
  }

  updateMemberDetails(memberId, details) {
    const promise = this.memberProfileResource.update(
      {
        memberId,
      },
      details
    ).$promise;

    return promise.catch((error) => {
      throw this.apiService.getErrorMessage(error);
    });
  }

  _setUserObject({
    accountId: account_id,
    firstName: first_name,
    lastName: last_name,
    email,
    userType: role,
    displayUserType: display_name,
    dob: dob,
  }) {
    let obj = { first_name, last_name, email, role, display_name, dob };
    if (account_id) {
      obj.account_id = account_id;
    }
    return obj;
  }

  _setUserListFilterObject({
    pageId = 1,
    limit = 10,
    sortBy,
    status,
    source,
    rankId,
    timeline,
    department,
    timelineIds,
    searchKeyword,
    maritalStatus,
    batchServiceId,
    excludeCounselor,
    militaryOccupation,
    preferredLocation = null,
    isMemberAssignedToCounselor,
    subscribeToWeeklyNewsletter,
    memberWithContactNumber = false,
    referredSources = [],
  }) {
    let obj = { pageId, limit };
    if (source) {
      obj.source = source;
    }
    if (rankId) {
      obj.rankId = rankId;
    }
    if (sortBy) {
      obj.sortBy = sortBy;
    }
    if (maritalStatus) {
      obj.maritalStatus = maritalStatus;
    }
    if (batchServiceId) {
      obj.batchServiceId = batchServiceId;
    }
    if (department) {
      obj.department = department;
    }
    if (timelineIds && timelineIds.length > 0) {
      obj["timelineIds[]"] = timelineIds;
    }
    if (preferredLocation && preferredLocation.length > 0) {
      obj["preferredLocation[]"] = preferredLocation;
    }
    if (status) {
      obj.status = status;
    }
    if (militaryOccupation) {
      obj.militaryOccupation = militaryOccupation;
    }
    if (timeline) {
      obj.isSpouseChecklist = timeline.toLowerCase() === "spouse checklist";
    }
    if (isMemberAssignedToCounselor) {
      obj.isMemberAssignedToCounselor = isMemberAssignedToCounselor;
    }
    if (excludeCounselor) {
      obj.excludeCounselor = excludeCounselor;
    }
    if (memberWithContactNumber) {
      obj.memberWithContactNumber = true;
    }
    if (searchKeyword) {
      obj.searchKeyword = searchKeyword;
    }
    if (subscribeToWeeklyNewsletter) {
      obj.subscribeToWeeklyNewsletter = subscribeToWeeklyNewsletter;
    }
    if (referredSources) {
      obj["referredSources[]"] = referredSources;
    }
    return obj;
  }

  _setUserExportParams(roles) {
    let _roles = "";
    if (roles && roles.length > 0) {
      roles.map((value) => {
        _roles = _roles + `roles[]=${value}&`;
      });
      return _roles;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/user/user.service.js